import React from 'react'
import { PDFCardProps } from './types'
import { View } from '@react-pdf/renderer'
import getStyles from './styles'

function PDFCard({ children, style, noGutters }: PDFCardProps) {
  const baseStyle = getStyles({ noGutters })

  return <View style={{ ...baseStyle.container, ...style }}>{children}</View>
}

export default PDFCard
